export default {
    loadEventProgram: function (eventId, program, categories, fetchTime, recommendedFilter) {
        return {type: 'EVENT_PROGRAM_LOADED', eventId, program, categories, fetchTime, recommendedFilter};
    },
    updateProgramSelection: function (eventId, selectedItems, deselectedItems, updatedItem) {
        const userId = app.store.getState().session.user.id
        return {type: 'EVENT_PROGRAM_SELECTION_UPDATE', eventId, selectedItems, deselectedItems, updatedItem, userId};
    },
    updateProgramItem: function (eventId, programId, data) {
        return {type: 'EVENT_PROGRAM_UPDATE', eventId, programId, data};
    },
    //
    setFilter: function (eventId, filter) {
        return {type: 'EVENT_PROGRAM_SET_FILTER', eventId, filter};
    },
    setFilterText: function (eventId, text) {
        return {type: 'EVENT_PROGRAM_SET_FILTER_TEXT', eventId, text};
    },
    addFilterCategoryOption: function (eventId, category, option) {
        return {type: 'EVENT_PROGRAM_ADD_FILTER_CATEGORY_OPTION', eventId, category, option};
    },
    removeFilterCategoryOption: function (eventId, category, option) {
        return {type: 'EVENT_PROGRAM_REMOVE_FILTER_CATEGORY_OPTION', eventId, category, option};
    },
    setFilterCategories: function (eventId, filterCategories) {
        return {type: 'EVENT_PROGRAM_SET_FILTER_CATEGORIES', eventId, filterCategories};
    },
    clearFilterCategories: function (eventId) {
        return {type: 'EVENT_PROGRAM_CLEAR_FILTER_CATEGORIES', eventId};
    },
    clearFilter: function (eventId) {
        return {type: 'EVENT_PROGRAM_CLEAR_FILTER', eventId};
    },
    applyRecommendedFilter: function (eventId) {
        return {type: 'EVENT_PROGRAM_APPLY_RECOMMENDED_FILTER', eventId};
    },
};
